// extracted by mini-css-extract-plugin
module.exports = {"power-independence-D":"D_power-independence-D__JwAr6"};